import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SystemSettingContext = createContext({
    setting: null,
    refreshSetting: () => {}
});

export const SystemSettingProvider = ({ children }) => {
    const [setting, setSetting] = useState(null);

    const fetchSetting = () => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/setting/get`)
            .then((res) => {
                if (res.data?.data) {
                    const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                    
                    const formatUrl = (url) => {
                        if (!url) return "";
                        if (url.startsWith("http://") && window.location.protocol === "https:") {
                            url = url.replace("http://", "https://");
                        }
                        if (url.startsWith("http://") || url.startsWith("https://")) return url;
                        if (url.startsWith("/")) return `${process.env.REACT_APP_API_URL}${url}`;
                        return `${process.env.REACT_APP_API_URL}/${url}`;
                    };

                    if (data.site_logo) data.site_logo = formatUrl(data.site_logo);
                    if (data.site_logo_mobile) data.site_logo_mobile = formatUrl(data.site_logo_mobile);
                    if (data.site_favicon) data.site_favicon = formatUrl(data.site_favicon);

                    setSetting(data);

                    // Dynamic Title
                    const pageTitle = data.site_title || data.site_name ? `${data.site_title || data.site_name} | Quản Trị Admin` : "MM68 - Hệ Thống Quản Trị Admin";
                    document.title = pageTitle;

                    // Dynamic Favicon with Logo fallback
                    const favTarget = data.site_favicon || data.site_logo || data.site_logo_mobile;
                    if (favTarget) {
                        ["link[rel*='icon']", "link[rel='shortcut icon']", "link[rel='apple-touch-icon']"].forEach(selector => {
                            let link = document.querySelector(selector);
                            if (!link) {
                                link = document.createElement("link");
                                link.rel = selector.includes("apple") ? "apple-touch-icon" : "icon";
                                document.getElementsByTagName("head")[0].appendChild(link);
                            }
                            link.href = favTarget;
                        });
                    }

                    // OpenGraph SEO Meta Image Tags (og:image & twitter:image)
                    const seoLogo = data.site_logo || data.site_logo_mobile || favTarget;
                    if (seoLogo) {
                        let ogImg = document.querySelector("meta[property='og:image']") || document.querySelector("meta[name='og:image']");
                        if (!ogImg) {
                            ogImg = document.createElement("meta");
                            ogImg.setAttribute("property", "og:image");
                            document.getElementsByTagName("head")[0].appendChild(ogImg);
                        }
                        ogImg.setAttribute("content", seoLogo);

                        let twImg = document.querySelector("meta[name='twitter:image']");
                        if (!twImg) {
                            twImg = document.createElement("meta");
                            twImg.setAttribute("name", "twitter:image");
                            document.getElementsByTagName("head")[0].appendChild(twImg);
                        }
                        twImg.setAttribute("content", seoLogo);
                    }
                }
            })
            .catch((err) => {
                console.log("Load system setting error:", err);
            });
    };

    useEffect(() => {
        fetchSetting();
    }, []);

    return (
        <SystemSettingContext.Provider value={{ setting, refreshSetting: fetchSetting }}>
            {children}
        </SystemSettingContext.Provider>
    );
};

export const useSystemSetting = () => useContext(SystemSettingContext);
